import { Group, Text } from "@mantine/core";
import { IconEye, IconSparkles } from "@tabler/icons-react";

interface Props {
  viewCount: number | null;
  isFresh: boolean;
}

const formatter = new Intl.NumberFormat("en-US");

// Social-proof pill for the Posts/Show meta bar. Renders one of:
//   • "Read by 1,240 dancers"   — normal case, view_count from Plausible
//   • "Just published"          — post is < 7 days old (isFresh)
//   • nothing                   — Plausible unauthed / offline / no data
// Reusable in KeepReading and post list previews later.
export function PostStats({ viewCount, isFresh }: Props) {
  if (isFresh) {
    return (
      <Group gap={4} wrap="nowrap" c="dimmed">
        <IconSparkles size={14} stroke={1.75} />
        <Text size="sm" c="dimmed">
          Just published
        </Text>
      </Group>
    );
  }

  if (viewCount == null || viewCount <= 0) return null;

  return (
    <Group gap={4} wrap="nowrap" c="dimmed">
      <IconEye size={14} stroke={1.75} />
      <Text size="sm" c="dimmed">
        Read by {formatter.format(viewCount)} {viewCount === 1 ? "dancer" : "dancers"}
      </Text>
    </Group>
  );
}

export default PostStats;
